export default {
    methods: {
        goToListWithPreFilteredOption (filter, filterKey) {
            this.$store.dispatch('Search/setViewType', 'all')
            this.$store.dispatch('Search/setQuery', null)
            this.$store.dispatch('Search/clearAllFilters')
            this.$store.dispatch('Search/setSearchComponentKey')

            this.$store.dispatch('Search/addFilterValue', {
                key: filterKey,
                value: filter.id.toString(),
                label: filter.label.toString()
            })

            this.$router.push({ name: 'all-packages-all-content' })
        }
    }
}
